import {
  FaClipboardCheck,
  FaHistory,
  FaSearch,
  FaThLarge,
  FaUserShield,
  FaWhatsapp,
} from 'react-icons/fa';

export const WHATSAPP_HELP_URL = 'https://wa.me/918318959079';

export const DASHBOARD_NAV_ITEMS = [
  {
    id: 'home',
    page: 'home',
    label: 'Dashboard',
    description: 'Assets & nominees',
    icon: FaThLarge,
  },
  {
    id: 'nominee-check',
    page: 'nominee-check',
    label: 'Notify All Nominees',
    description: 'By account holder email',
    icon: FaClipboardCheck,
  },
  {
    id: 'nominee-lookup',
    page: 'nominee-lookup',
    label: 'Nominee Lookup',
    description: 'Find records by nominee contact',
    icon: FaSearch,
  },
  {
    id: 'verification-history',
    page: 'verification-history',
    label: 'Verification History',
    description: 'Paid & unpaid checks',
    icon: FaHistory,
  },
];

export const ADMIN_NAV_ITEM = {
  id: 'admin',
  page: 'admin',
  label: 'Admin',
  description: 'Users, tracking & payments',
  icon: FaUserShield,
};

export const HELP_NAV_ITEM = {
  id: 'help',
  label: 'Help',
  description: 'Chat with us on WhatsApp',
  icon: FaWhatsapp,
  externalHref: WHATSAPP_HELP_URL,
};

export function getDashboardNavItems(isAdmin) {
  const items = isAdmin
    ? [...DASHBOARD_NAV_ITEMS, ADMIN_NAV_ITEM]
    : [...DASHBOARD_NAV_ITEMS];
  return [...items, HELP_NAV_ITEM];
}

export function getNavHandler(item, handlers) {
  const map = {
    home: handlers.onNavigateHome,
    'nominee-check': handlers.onNavigateNomineeCheck,
    'nominee-lookup': handlers.onNavigateNomineeLookup,
    'verification-history': handlers.onNavigateVerificationHistory,
    admin: handlers.onNavigateAdmin,
  };
  return map[item.page];
}
